import React from 'react';

const AboutCard = ({ icon, title, description, features, delay }) => {
  return (
    <div className="about-card visible" style={{ transitionDelay: delay }}>
      <div className="card-icon-wrapper">
        <span className="card-icon">{icon}</span>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      <div className="card-feature-list">
        {features.map((feature, index) => (
          <div key={index} className="feature-item">
            <span className="check-icon">✓</span>
            <span className="feature-text">{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutCard;